import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { SectionReveal } from './ui/SectionReveal';
import { useLanguage } from '../context/LanguageContext';
export function DeveloperSection() {
  const {
    t
  } = useLanguage();
  const [showArchitect, setShowArchitect] = useState(false);
  const [showEnergy, setShowEnergy] = useState(false);
  return <SectionReveal id="quienes-somos" className="bg-white py-24" data-id="element-127" data-mp="29nl95uqf70l0">
      <div className="container mx-auto px-6 md:px-12 max-w-6xl" data-id="element-128" data-mp="29n1t6jkbym9m">
        <h2 className="text-4xl md:text-6xl font-serif text-navy text-center mb-16" data-id="element-129" data-mp="2elv4c5c5a16m">
          {t.developer.title}
        </h2>

        {/* Top Cards Row */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-130" data-mp="2jjwpqwx1mcl9">
          {/* Promotora Tab (Flush with bottom section on desktop) */}
          <div className="hidden md:flex flex-col justify-end" data-id="element-131" data-mp="p8hww78qjx1a">
            <div className="bg-navy p-8 w-full" data-id="element-132" data-mp="pa2nxmvucxue">
              <h3 className="text-white font-bold text-xl" data-id="element-133" data-mp="u7m4itg0hmpi">
                {t.developer.tabs.promoter}
              </h3>
            </div>
          </div>

          {/* Arquitectos */}
          <div className="bg-nature p-8 flex flex-col justify-between min-h-[160px]" data-id="element-134" data-mp="29mpdcwo2ag00">
            <h3 className="text-white font-bold text-xl" data-id="element-135" data-mp="24ncvkqc1rz4a">
              {t.developer.tabs.architects}
            </h3>
            <button type="button" onClick={() => setShowArchitect(v => !v)} aria-expanded={showArchitect} className="text-white text-sm hover:underline mt-8 inline-block text-left" data-id="element-136" data-mp="1zpuhklj6atpf">
              {t.developer.learnMore}
            </button>
          </div>

          {/* Calificación */}
          <div className="bg-navy p-8 flex flex-col justify-between min-h-[160px]" data-id="element-137" data-mp="2jcshnt0mvgdn">
            <h3 className="text-white font-bold text-xl" data-id="element-138" data-mp="2jf4xo0mtzgo2">
              {t.developer.tabs.energy}
            </h3>
            <button type="button" onClick={() => setShowEnergy(v => !v)} aria-expanded={showEnergy} className="text-white text-sm hover:underline mt-8 inline-block text-left" data-id="element-139" data-mp="17xn39rr53te7">
              {t.developer.learnMore}
            </button>
          </div>
        </div>

        {/* Arquitectos detail panel */}
        <AnimatePresence initial={false} data-id="element-140" data-mp="zipdft4nrd68">
          {showArchitect && <motion.div initial={{
          opacity: 0,
          height: 0
        }} animate={{
          opacity: 1,
          height: 'auto'
        }} exit={{
          opacity: 0,
          height: 0
        }} transition={{
          duration: 0.3,
          ease: 'easeInOut'
        }} className="overflow-hidden" data-id="element-141" data-mp="14e4qiiuud51l">
              <div className="bg-nature/10 border-l-4 border-nature p-8 md:p-10 mt-6" data-id="element-142" data-mp="7qhz4zcmkcv0">
                <h4 className="font-serif text-2xl text-navy mb-4" data-id="element-143" data-mp="braaby524rtx">
                  {t.developer.architect.name}
                </h4>
                <div className="space-y-4 text-navy/80 text-lg leading-relaxed max-w-3xl" data-id="element-144" data-mp="3p8e4fsn6b9d6">
                  <p data-id="element-145" data-mp="3kam2e5ste6v9">{t.developer.architect.p1}</p>
                  <p data-id="element-146" data-mp="236ey6t6hih9">{t.developer.architect.p2}</p>
                </div>
              </div>
            </motion.div>}
        </AnimatePresence>

        {/* Calificación energética detail panel */}
        <AnimatePresence initial={false} data-id="element-147" data-mp="c12k8hzfpj7g">
          {showEnergy && <motion.div initial={{
          opacity: 0,
          height: 0
        }} animate={{
          opacity: 1,
          height: 'auto'
        }} exit={{
          opacity: 0,
          height: 0
        }} transition={{
          duration: 0.3,
          ease: 'easeInOut'
        }} className="overflow-hidden" data-id="element-148" data-mp="bz9dl2otmyzg">
              <div className="bg-navy/5 border-l-4 border-navy p-8 md:p-10 mt-6" data-id="element-149" data-mp="pqwan4ql8bja">
                <h4 className="font-serif text-2xl text-navy mb-4" data-id="element-150" data-mp="19ulp549vnvfs">
                  {t.developer.energy.title}
                </h4>
                <div className="space-y-4 text-navy/80 text-lg leading-relaxed max-w-3xl" data-id="element-151" data-mp="1inf9vh83fn11">
                  <p data-id="element-152" data-mp="1iprq9py7dpbz">{t.developer.energy.p1}</p>
                  <p data-id="element-153" data-mp="1nlgqlvi1ra9c">{t.developer.energy.p2}</p>
                  <p data-id="element-154" data-mp="1nocqvqhdab0y">{t.developer.energy.p3}</p>
                  <p data-id="element-155" data-mp="qxatdtngfk53">{t.developer.energy.p4}</p>
                </div>
              </div>
            </motion.div>}
        </AnimatePresence>

        {/* Bottom Content Area */}
        <div className="bg-navy p-8 md:p-12" data-id="element-156" data-mp="zwecgxmmfzjl">
          <div className="md:hidden mb-8" data-id="element-157" data-mp="zvmh9nwxs3tu">
            <h3 className="text-white font-bold text-xl border-b border-white/20 pb-4" data-id="element-158" data-mp="14wjwpsqkajrn">
              {t.developer.tabs.promoter}
            </h3>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-159" data-mp="2be707y2h9hgg">
            {/* Left: Logo Card */}
            <div className="bg-white p-8 md:p-12 shadow-xl flex items-center justify-center aspect-video md:aspect-[4/3]" data-id="element-160" data-mp="4nu9q7z3h8qf">
              <img src="https://cdn.magicpatterns.com/uploads/eWststvYB2BbqkWme1dX8N/ChatGPT_Image_11_jun_2026,_17_15_05.png" alt="PIBASA Logo" className="w-full h-auto object-contain max-w-[85%]" data-id="element-161" data-mp="3vtlokb7f8yxx" />
            </div>

            {/* Right: Text Content */}
            <div className="text-white" data-id="element-162" data-mp="3i3runeh27ohc">
              <h3 className="text-4xl md:text-5xl font-serif mb-6" data-id="element-163" data-mp="3i0dtuao1nnc0">PIBASA</h3>
              <div className="space-y-6 text-white/90 text-lg leading-relaxed" data-id="element-164" data-mp="3d22ni9wyjuyj">
                <p className="font-bold" data-id="element-165" data-mp="385c5hh1lepah">{t.developer.pibasa.p1}</p>
                <p data-id="element-166" data-mp="335zjeyijpm8y">{t.developer.pibasa.p2}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </SectionReveal>;
}